
import React from 'react';
import { Col, FormGroup, Checkbox, Button, Radio } from 'react-bootstrap';

class ProfileFilters extends React.Component {
  profiles = [
    'All',
    'Models',
    'Non Models'
  ]

  updateProfiles(e){
    this.props.updateProfiles(e.target.value);
  }

  render(){
    const self = this;
    return(
      <Col md={8}>
        <label className="control-label" style={{marginRight: '20px'}}>Profiles</label>
        <FormGroup style={{flex: 1}}>
          {
            self.profiles.map(function(profiles){
              return(
                <Radio
                  name="profile_types"
                  key={profiles}
                  onChange={self.updateProfiles.bind(self)}
                  value={profiles}
                  checked={self.props.selectedProfiles == profiles}
                  inline
                >
                  {profiles}
                </Radio>
              )
            })
          }
        </FormGroup>
      </Col>
    )
  }
}

export default ProfileFilters;
